import { ACCESS_CATALOG } from './access-catalog.generated';

/** Web and Mobile App grants are separate entries in the server catalogue. */
export type PermissionKey =
  | (typeof ACCESS_CATALOG.panel)[number]['submodules'][number]['areas'][number]
  | (typeof ACCESS_CATALOG.app)[number]['submodules'][number]['areas'][number];

export const WEB_PAGES = ACCESS_CATALOG.panel.flatMap(group => group.submodules.map(page => ({
  key: page.key as PermissionKey,
  label: page.label,
  group: group.label,
  groupKey: group.key as string,
  url: 'url' in page ? page.url : undefined,
})));

/** Actions and Mobile App grants deliberately have no web landing page. */
export const AREA_LANDING = WEB_PAGES.filter((page): page is typeof page & {url: string} => !!page.url);
export const NO_ACCESS_URL = '/admin/no-access';
export function pageGroup(key: string) { return WEB_PAGES.filter(page => page.groupKey === key); }
